import styled from 'styled-components';
import { Card, Tag, Modal, Form, Select, Button, message } from 'antd';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Country } from '../../methods/utils/request-helpers';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { getUserWalletBalance } from '../../methods/redux/reducers/user-profile';
import AdminWalletBalances from '../admin-profile/WalletBalances';
import VirtualDepositAccounts from '../admin-profile/VirtualDepositAccounts';
import UserQuickActions from './quick-actions/UserQuickActions';
import baseuri from '../../methods/baseuri';

const OtherSectionStyle = styled.div`
	display: flex;
	flex: 2;
	flex-direction: column;
	gap: 1rem;
	height: auto;
	width: 100%;
`;

const DeviceCard = styled(Card)`
	display: flex;
	flex-direction: column;

	& .title {
		display: flex;
		gap: 1em;
	}
`;
const DetailsMain = styled.div`
	display: flex;
	flex: 1;

	& .items {
		display: flex;
		flex-direction: column;
		flex: 1;
		gap: 1em;
	}
`;

const OtherDetailsSection = () => {
	const dispatch = useAppDispatch();
	const { user, walletBalance } = useAppSelector((store) => store.userProfile);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();

	useEffect(() => {
		if (user.profile?._id) {
			dispatch(getUserWalletBalance(user.profile?._id));
		}
	}, [user.profile]);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
	};

	const handleSubmit = async (values: any) => {
		try {
			setLoading(true);
			const payload = {
				userId: user.profile?._id,
				providerKey: values.providerKey,
				isShortLived: Boolean(values.isShortLived),
				amountControl: values.amountControl,
			};
			await baseuri.post('/admin/virtual-fiat-accounts/generate', payload);
			message.success('Virtual Fiat Account generated successfully');
			handleCancel();
		} catch (error: any) {
			message.error(error?.response?.data?.message || 'An error occurred');
		} finally {
			setLoading(false);
		}
	};

	const details = user;

	return (
		<OtherSectionStyle>
			<Card>
				<AdminWalletBalances
					balances={walletBalance.cryptoBalances.concat(
						walletBalance.fiatBalances
					)}
					walletAddress={walletBalance.walletAddress}
				/>
				<div>
					<VirtualDepositAccounts />
				</div>
				<div style={{ marginBottom: '10px' }}>
					<p className="title" style={{ marginBottom: '10px' }}>
						{' '}
						<strong>Generate Virtual Fiat Account:</strong>
					</p>
					<Button type="primary" onClick={showModal}>
						Generate Virtual Fiat Account
					</Button>
				</div>
				<div>
					<p className="title" style={{ marginBottom: '10px' }}>
						{' '}
						<strong>Virtual Fiat Accounts:</strong>
					</p>
					<Link
						to={`/core-modules/virtual-fiat-accounts?userId=${user.profile?._id}`}
					>
						<p className="title"> Click to view all virtual fiat accounts</p>
					</Link>
				</div>
			</Card>
			<DeviceCard>
				<div className="title">
					<strong>Registration Device Details</strong>
					<i className="material-icons" style={{ fontSize: 16 }}>
						phone_iphone
					</i>
					<span>{details?.profile?.registrationDeviceDetails?.type}</span>
					{details?.profile?.registrationCoordinates && (
						<a
							target="_blank"
							href={`https://maps.google.com/maps?f=q&q=${details?.profile?.registrationCoordinates?.lat},${details?.profile?.registrationCoordinates?.long}`}
							rel="noreferrer"
						>
							View Location
						</a>
					)}
				</div>
				<DetailsMain>
					<div className="items">
						<div>
							<p>Build</p>
							<strong>
								{details?.profile?.registrationDeviceDetails?.build || '--'}
							</strong>
						</div>
						<div>
							<p>Description</p>
							<strong>
								{details?.profile?.registrationDeviceDetails?.description ||
									'--'}
							</strong>
						</div>
					</div>
					<div className="items">
						<div>
							<p>Serial No</p>
							<strong>
								{details?.profile?.registrationDeviceDetails?.serial || '--'}
							</strong>
						</div>
						<div>
							<p>country</p>
							<strong>
								{Country(
									details?.profile?.registrationDeviceDetails?.cfIpCountry
								) || '--'}
							</strong>
						</div>
					</div>
				</DetailsMain>
			</DeviceCard>
			<DeviceCard>
				<div className="title">
					<strong>Last Login Device Details</strong>
					<i className="material-icons" style={{ fontSize: 16 }}>
						phone_iphone
					</i>
					<span>{details?.lastDeviceLogin[0]?.userDevice?.type || '--'}</span>
					{details?.lastDeviceLogin[0]?.locationCoordinates && (
						<a
							target="_blank"
							href={`https://maps.google.com/maps?f=q&q=${details?.lastDeviceLogin[0]?.locationCoordinates?.lat},${details?.lastDeviceLogin[0]?.locationCoordinates?.long}`}
							rel="noreferrer"
						>
							View Location
						</a>
					)}
				</div>
				<DetailsMain>
					<div className="items">
						<div>
							<p>Build</p>
							<strong>
								{details?.lastDeviceLogin[0]?.userDevice?.build || '--'}
							</strong>
						</div>
						<div>
							<p>Description</p>
							<strong>
								{details?.lastDeviceLogin[0]?.userDevice?.description || '--'}
							</strong>
						</div>
						<div>
							<p>Serial No</p>
							<strong>
								{details?.lastDeviceLogin[0]?.userDevice?.serial || '--'}
							</strong>
						</div>
					</div>
					<div className="items">
						<div>
							<p>Device country</p>
							<strong>
								{Country(
									details?.lastDeviceLogin[0]?.userDevice?.deviceCountry
								) || '--'}
							</strong>
						</div>
						<div>
							<p>IP country</p>
							<strong>
								{Country(
									details?.lastDeviceLogin[0]?.userDevice?.cfIpCountry
								) || '--'}
							</strong>
						</div>
						<div>
							<p>IP Address</p>
							<strong>
								<Tag>
									{details?.lastDeviceLogin[0]?.userDevice?.clientIP || '--'}
								</Tag>
							</strong>
						</div>
					</div>
				</DetailsMain>
			</DeviceCard>
			<UserQuickActions details={details} />

			<Modal
				title="Generate Virtual Fiat Account"
				visible={isModalVisible}
				onCancel={handleCancel}
				footer={null}
				destroyOnClose={true}
			>
				<Form
					form={form}
					onFinish={handleSubmit}
					layout="vertical"
					initialValues={{ amountControl: 'OverPayment' }}
				>
					<Form.Item
						name="providerKey"
						label="Provider Key"
						rules={[
							{ required: true, message: 'Please select a provider key!' },
						]}
					>
						<Select placeholder="Select provider key">
							<Select.Option value="SAFE_HAVEN">SAFE HAVEN</Select.Option>
							<Select.Option value="BELLBANK">BELL BANK</Select.Option>
							<Select.Option value="PALMPAY">PALM PAY</Select.Option>
						</Select>
					</Form.Item>

					<Form.Item
						name="isShortLived"
						label="Is Short Lived"
						rules={[{ required: true, message: 'Please select!' }]}
					>
						<Select placeholder="Select">
							<Select.Option value="true">True</Select.Option>
							<Select.Option value="false">False</Select.Option>
						</Select>
					</Form.Item>
					<Form.Item name="amountControl" label="Amount Control">
						<Select placeholder="Select amount control">
							<Select.Option value="Fixed">Fixed</Select.Option>
							<Select.Option value="UnderPayment">UnderPayment</Select.Option>
							<Select.Option value="OverPayment">OverPayment</Select.Option>
						</Select>
					</Form.Item>

					<Form.Item>
						<Button type="primary" htmlType="submit" loading={loading}>
							{loading ? 'Generating...' : 'Generate'}
						</Button>
						<Button onClick={handleCancel} style={{ marginLeft: '8px' }}>
							Cancel
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</OtherSectionStyle>
	);
};
export default OtherDetailsSection;
